<div>
  <div
    class="empty-auction-location"
    *ngIf="locationLength <= 0; else showLocations"
  >
    <div class="not-found">
      <img
        alt="not-found-icon"
        class="not-found-icon"
        src="../assets/images/location.svg"
      />
      <h3 class="not-added">Location not added</h3>
      <p class="sub-hdg">To add a Location first</p>
      <button
        class="btn btn-colored"
        role="button"
        (click)="openLocationModal(locationModal)"
      >
        + Add Location
      </button>
    </div>
  </div>

  <ng-template #showLocations>
    <div class="row location-header-row mb-4">
      <div class="col-12 col-md-8 col-lg-9">
        <span class="heading-20">Locations</span>
        <span class="body-text-14 mt-1 mb-2 mb-md-0"
          >These locations will be published on the Auction detail page</span
        >
      </div>

      <div class="col-12 col-md-4 col-lg-3 align-self-end">
        <span class="float-right">
          <button
            type="submit"
            class="btn btn-colored"
            role="button"
            (click)="openLocationModal(locationModal)"
          >
            + Add Location
          </button>
        </span>
      </div>
    </div>

    <div class="row">
      <div class="col-12">
        <section class="data-table-wrap w-100">
          <table
            aria-label="locationTable"
            mat-table
            [dataSource]="locations"
            #locationTable
            class="mat-elevation-z8 dark-table add-contact-table"
          >
            <ng-container matColumnDef="locationName">
              <th
                scope="col"
                mat-header-cell
                *matHeaderCellDef
                class="column-1 listing-header-name"
              >
                Location Name
              </th>
              <td
                class="column-1 listing-data-entry name table-grey-row"
                mat-cell
                *matCellDef="let element"
                data-column="Location Name"
              >
                <span>
                  {{ element.name | isEmpty }}
                </span>
              </td>
            </ng-container>

            <ng-container matColumnDef="address">
              <th
                scope="col"
                class="column-2 listing-header-name"
                mat-header-cell
                *matHeaderCellDef
              >
                Address
              </th>
              <td
                mat-cell
                class="column-2 listing-data-entry name"
                data-column="Address"
                *matCellDef="let element"
              >
                <span
                  [innerHTML]="element.address | isEmpty | sanitizedHtml"
                ></span>
              </td>
            </ng-container>

            <ng-container matColumnDef="lot">
              <th
                scope="col"
                class="column-3 listing-header-name"
                mat-header-cell
                *matHeaderCellDef
              >
                Lot #
              </th>
              <td
                class="column-3 listing-data-entry name table-grey-row"
                data-column="Lot #"
                mat-cell
                *matCellDef="let element"
              >
                <span>{{ element.lotNumbers | isEmpty: "TBD" }}</span>
              </td>
            </ng-container>

            <ng-container matColumnDef="action">
              <th
                scope="col"
                class="column-4 listing-header-name"
                mat-header-cell
                *matHeaderCellDef
              ></th>
              <td
                class="column-4 listing-data-entry name"
                mat-cell
                *matCellDef="let element; let i = index"
              >
                <div class="for-icons">
                  <a
                    class="hover-icon edit-icon mr-2"
                    role="button"
                    (click)="openLocationModal(locationModal, true, i)"
                  ></a>
                  <button
                    type="button"
                    class="hover-icon delete-icon"
                    role="button"
                    (click)="openDeleteModal(deletePopup, 1, i)"
                  ></button>
                </div>
              </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr
              mat-row
              *matRowDef="let row; columns: displayedColumns"
              [hidden]="row.isDeleted == true"
            ></tr>
          </table>
        </section>
      </div>
    </div>
  </ng-template>

  <div
    class="empty-auction-location"
    *ngIf="contactLength <= 0; else showContacts"
  >
    <div class="not-found border-top-only">
      <img
        alt="not-found-icon"
        class="not-found-icon"
        src="../assets/images/contact.svg"
      />
      <h3 class="not-added">Contact not added</h3>
      <p class="sub-hdg">To add your first contact for your auction</p>
      <button
        class="btn btn-colored"
        role="button"
        (click)="openContactModal(contactModal)"
      >
        + Add Contact
      </button>
    </div>
  </div>

  <ng-template #showContacts>
    <div class="row location-header-row mt-0 mt-md-4 pt-3">
      <div class="col-12 col-md-8 col-lg-9">
        <span class="heading-20">Contacts</span>
        <span class="body-text-14 mt-1 mb-2 mb-md-0"
          >These contacts will be published on the Auction detail page</span
        >
      </div>
      <div class="col-12 col-md-4 col-lg-3 align-self-end">
        <span class="float-right">
          <button
            type="submit"
            class="btn btn-colored"
            role="button"
            (click)="openContactModal(contactModal)"
          >
            + Add Contacts
          </button>
        </span>
      </div>
    </div>

    <div class="row">
      <div class="col-12 mt-4">
        <section class="data-table-wrap w-100">
          <table
            aria-label="contactTable"
            mat-table
            [dataSource]="contacts"
            #contactTable
            class="mat-elevation-z8 dark-table add-loaction-table"
          >
            <ng-container matColumnDef="contactName">
              <th
                scope="col"
                class="column-1 listing-header-name"
                mat-header-cell
                *matHeaderCellDef
              >
                Contact Name
              </th>
              <td
                class="column-1 listing-data-entry name table-grey-row"
                data-column="Contact Name"
                mat-cell
                *matCellDef="let element"
              >
                {{ element.contactName | isEmpty }}
              </td>
            </ng-container>

            <ng-container matColumnDef="address">
              <th
                scope="col"
                class="column-2 listing-header-name"
                mat-header-cell
                *matHeaderCellDef
              >
                Designation
              </th>
              <td
                class="column-2 listing-data-entry name"
                data-column="Designation"
                mat-cell
                *matCellDef="let element"
              >
                {{ element.description | isEmpty }}
              </td>
            </ng-container>

            <ng-container matColumnDef="email">
              <th
                scope="col"
                class="column-3 listing-header-name"
                mat-header-cell
                *matHeaderCellDef
              >
                Email
              </th>
              <td
                class="column-3 listing-data-entry name table-grey-row"
                data-column="Email"
                mat-cell
                *matCellDef="let element"
              >
                {{ element.email | isEmpty }}
              </td>
            </ng-container>

            <ng-container matColumnDef="mobileNumber">
              <th
                scope="col"
                class="column-4 listing-header-name"
                mat-header-cell
                *matHeaderCellDef
              >
                Phone Number
              </th>
              <td
                class="column-4 listing-data-entry name"
                data-column="Phone Number"
                mat-cell
                *matCellDef="let element"
              >
                {{ element.mobileNumber | isEmpty }}
              </td>
            </ng-container>

            <ng-container matColumnDef="action">
              <th
                scope="col"
                class="column-5 listing-header-name"
                mat-header-cell
                *matHeaderCellDef
              ></th>
              <td
                class="column-5 listing-data-entry name"
                mat-cell
                *matCellDef="let element; let i = index"
              >
                <div class="for-icons">
                  <a
                    class="hover-icon edit-icon mr-2"
                    role="button"
                    (click)="openContactModal(contactModal, true, i)"
                  ></a>
                  <button
                    type="button"
                    class="hover-icon delete-icon"
                    role="button"
                    (click)="openDeleteModal(deletePopup, 2, i)"
                  ></button>
                </div>
              </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="displayedColumns2"></tr>
            <tr
              mat-row
              *matRowDef="let row; columns: displayedColumns2"
              [hidden]="row.isDeleted == true"
            ></tr>
          </table>
        </section>
      </div>
    </div>
  </ng-template>

  <div class="row">
    <div class="col-12">
      <div class="steps-btn-wrap pt-4 mt-2">
        <button
          class="btn btn-white-border mr-2 half-mob"
          role="button"
          (click)="onCancel()"
        >
          Cancel
        </button>
        <button
          class="btn btn-white-border mr-2 half-mob"
          role="button"
          (click)="goToStep()"
        >
          Back
        </button>
        <button
          type="submit"
          class="btn btn-colored full-mob"
          role="button"
          (click)="onSendAndApproval(true)"
          [disabled]="locationDisable || contactDisable || loading">
          {{ editMode ? "Finish" : "Send For Approval" }}
        </button>
      </div>
    </div>
  </div>
</div>

<ng-template #locationModal>
  <div class="modal-header">
    <h4 class="modal-title pull-left">Add New Location</h4>
    <button
      type="button"
      class="close pull-right p-0 m-0"
      aria-label="Close"
      role="button"
      (click)="closeModal()"
    >
      <img alt="cross-icon" src="../assets/images/cross.svg" />
    </button>
  </div>
  <div class="modal-body">
    <form (ngSubmit)="onLocationSave()" [formGroup]="locationForm">
      <div class="row">
        <div class="col-md-6 mat-field-width3">
          <div class="form-group">
            <mat-form-field appearance="outline">
              <mat-label>Location Name *</mat-label>
              <input
                matInput
                type="text"
                placeholder="Add Location Name"
                formControlName="name"
                [maxlength]="fieldMaxLengthMid"
              />
            </mat-form-field>
            <char-counter
              [control]="locationForm.controls.name"
              [maxlength]="fieldMaxLengthMid"
            >
            </char-counter>
            <control-messages
              [isFormSubmitted]="locationSubmitted"
              [control]="locationForm.controls.name"
            ></control-messages>
          </div>
        </div>
        <div class="col-md-6 mat-field-width3">
          <div class="form-group input-with-tooltip">
            <mat-form-field appearance="outline">
              <mat-label>Lot #</mat-label>
              <input
                matInput
                type="text"
                placeholder="Add Lot Numbers"
                formControlName="lotNumbers"
                [maxlength]="fieldMaxLength"
              />
            </mat-form-field>
            <char-counter
              [control]="locationForm.controls.lotNumbers"
              [maxlength]="fieldMaxLength"
            >
            </char-counter>
            <control-messages
              [isFormSubmitted]="locationSubmitted"
              [control]="locationForm.controls.lotNumbers"
            ></control-messages>

            <span
              class="custom-tooltip"
              #tooltip="matTooltip"
              matTooltipClass="custom-tooltip-icon custom-tooltip-max"
              matTooltip="Specify lot numbers for items  at this location"
              [matTooltipPosition]="'above'"
            >
              <img alt="info" src="../assets/images/info.svg" />
            </span>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-6 mat-field-width3">
          <div class="form-group">
            <div class="min-100">
              <p class="small-label2 mb-2">Address *</p>
              <editor
                [initialValue]="addressData"
                (editorData)="
                  editorContent($event, locationForm.controls.address)
                "
                [characterLimit]="fieldMaxLengthMediumMost"
              ></editor>
              <control-messages
                [isFormSubmitted]="locationSubmitted"
                [control]="locationForm.controls.address"
              ></control-messages>
            </div>
          </div>
        </div>
        <div class="col-md-6 mat-field-width3">
          <div class="form-group d-md-block">
            <mat-form-field appearance="outline">
              <mat-label>Sales Tax Rate(%) </mat-label>
              <input
                matInput
                placeholder="Add Rate"
                formControlName="salesTaxRate"
              />
            </mat-form-field>
            <control-messages
              [isFormSubmitted]="locationSubmitted"
              [control]="locationForm.controls.salesTaxRate"
            ></control-messages>
          </div>
          <div class="form-group d-md-block">
            <mat-form-field appearance="outline">
              <mat-label>Location URL</mat-label>
              <input
                matInput
                placeholder="Add Location's Google Map Url"
                formControlName="locationLink"
              />
            </mat-form-field>
            <control-messages
              [isFormSubmitted]="locationSubmitted"
              [control]="locationForm.controls.locationLink"
            ></control-messages>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12">
          <p class="small-label2 mb-2">Removal Dates & Rules *</p>
          <div class="mb-3 pb-1 min-250">
            <editor
              [initialValue]="removalData"
              (editorData)="
                editorContent($event, locationForm.controls.removalDateAndRules)
              "
              [characterLimit]="fieldMaxLengthMedium"
            ></editor>
            <control-messages
              [isFormSubmitted]="locationSubmitted"
              [control]="locationForm.controls.removalDateAndRules"
            ></control-messages>
          </div>
        </div>
        <div class="col-md-12">
          <p class="small-label2 mb-2">Sales Tax Details *</p>
          <div class="mb-3 pb-1 min-250">
            <editor
              [initialValue]="saletaxData"
              (editorData)="
                editorContent($event, locationForm.controls.salesTaxDetail)
              "
              [characterLimit]="fieldMaxLengthMuchLonger"
            ></editor>
            <control-messages
              [isFormSubmitted]="locationSubmitted"
              [control]="locationForm.controls.salesTaxDetail"
            ></control-messages>
          </div>
        </div>
        <div class="col-md-12">
          <p class="small-label2 mb-2">Inspection Preview *</p>
          <div class="mb-3 pb-1 min-250">
            <editor
              [initialValue]="inspectionData"
              (editorData)="
                editorContent($event, locationForm.controls.inspectionPreview)
              "
              [characterLimit]="fieldMaxLengthLong"
            ></editor>
            <control-messages
              [isFormSubmitted]="locationSubmitted"
              [control]="locationForm.controls.inspectionPreview"
            ></control-messages>
          </div>
        </div>
        <div class="col-md-12">
          <p class="small-label2 mb-2">Rigging/Shipping *</p>
          <div class="mb-0 pb-0 min-250">
            <editor
              [initialValue]="riggingData"
              (editorData)="
                editorContent($event, locationForm.controls.riggingAndShipping)
              "
              [characterLimit]="fieldMaxLengthLongest"
            ></editor>
            <control-messages
              [isFormSubmitted]="locationSubmitted"
              [control]="locationForm.controls.riggingAndShipping"
            ></control-messages>
          </div>
        </div>
      </div>

      <p class="error-msg" *ngIf="locationForm.invalid">
        Please fill all required field(s)
      </p>

      <div class="image-popup-wrap pt-4 mt-2">
        <p class="text-secondary">
          Kindly click on "Update Auction" button to make permanent changes
        </p>
        <button
          type="button"
          class="btn btn-white-border mr-2 font-15"
          role="button"
          (click)="closeModal()"
        >
          Cancel
        </button>
        <button type="submit" class="btn btn-colored font-15">
          {{showButtonText}} Location
          
        </button>
      </div>
    </form>
  </div>
</ng-template>

<ng-template #contactModal>
  <div class="modal-header">
    <h4 class="modal-title pull-left">Add New Contact</h4>
    <button
      type="button"
      class="close pull-right p-0 m-0"
      aria-label="Close"
      role="button"
      (click)="closeModal()"
    >
      <img alt="cross-icon" src="../assets/images/cross.svg" />
    </button>
  </div>
  <div class="modal-body">
    <form (ngSubmit)="onContactSave()" [formGroup]="contactForm">
      <div class="form-group">
        <div class="mat-field-width">
          <mat-form-field appearance="outline">
            <mat-label>Contact Name</mat-label>
            <input
              matInput
              type="text"
              placeholder="Enter contact name"
              formControlName="contactName"
              [maxlength]="fieldMaxLengthShort"
            />
          </mat-form-field>
          <char-counter
            [control]="contactForm.controls.contactName"
            [maxlength]="fieldMaxLengthShort"
          >
          </char-counter>
          <control-messages
            [isFormSubmitted]="contactSubmitted"
            [control]="contactForm.controls.contactName"
          ></control-messages>
        </div>
      </div>

      <div class="form-group">
        <div class="mat-field-width min-100">
          <mat-form-field appearance="outline">
            <mat-label>Designation</mat-label>
            <textarea
              matInput
              placeholder="Enter Designation"
              formControlName="description"
              [maxlength]="fieldMaxLengthShort"
            ></textarea>
          </mat-form-field>
          <char-counter
            [control]="contactForm.controls.description"
            [maxlength]="fieldMaxLengthShort"
          >
          </char-counter>
          <control-messages
            [isFormSubmitted]="contactSubmitted"
            [control]="contactForm.controls.description"
          ></control-messages>
        </div>
      </div>

      <div class="form-group">
        <div class="mat-field-width">
          <mat-form-field appearance="outline">
            <mat-label>Email</mat-label>
            <input
              matInput
              type="text"
              placeholder="Enter email"
              formControlName="email"
              [maxlength]="fieldMaxLengthShort"
            />
          </mat-form-field>
          <char-counter
            [control]="contactForm.controls.email"
            [maxlength]="fieldMaxLengthShort"
          >
          </char-counter>
          <control-messages
            [isFormSubmitted]="contactSubmitted"
            [control]="contactForm.controls.email"
          ></control-messages>
        </div>
      </div>

      <div class="form-group">
        <div class="mat-field-width">
          <mat-form-field appearance="outline">
            <mat-label>Phone Number</mat-label>
            <input
              matInput
              type="text"
              placeholder="Enter Phone Number"
              formControlName="mobileNumber"
            />
          </mat-form-field>
          <char-counter
            [control]="contactForm.controls.mobileNumber"
            [maxlength]="mobileNumberLength"
          >
          </char-counter>
          <control-messages
            [isFormSubmitted]="contactSubmitted"
            [control]="contactForm.controls.mobileNumber"
          ></control-messages>
        </div>
      </div>

      <p *ngIf="contactForm.invalid && contactSubmitted" class="error-msg">
        Please fill all required field(s)
      </p>

      <div class="image-popup-wrap pt-4 mt-2">
        <button
          type="button"
          class="btn btn-white-border mr-2"
          role="button"
          (click)="closeModal()"
        >
          Cancel
        </button>
        <button type="submit" class="btn btn-colored">{{showButtonText}} Contact</button>
      </div>
    </form>
  </div>
</ng-template>

<ng-template #deletePopup>
  <div class="modal-header">
    <h4 class="modal-title pull-left"></h4>
    <button
      type="button"
      class="close pull-right p-0 m-0"
      aria-label="Close"
      role="button"
      (click)="closeModal()"
    >
      <img alt="cross-icon" src="../assets/images/cross.svg" />
    </button>
  </div>
  <div class="modal-body">
    <div class="delete-data">
      <img alt="delete-icon" src="../assets/images/delete-icon.svg" />
      <h1 class="modal-inner-hdg mt-3">
        Delete {{ modalType == 1 ? "Location" : "Contact" }}
      </h1>
      <p class="des">
        Are you sure you want to delete
        <span class="for-highlight">{{
          modalType == 1 ? "Location" : "Contact"
        }}</span>
        ?
      </p>
      <div class="delete-btns">
        <button
          type="button"
          class="btn btn-text mr-2"
          role="button"
          (click)="closeModal()"
        >
          Cancel
        </button>
        <button
          class="btn btn-colored pad-22"
          role="button"
          (click)="
            modalType == 1
              ? onDeleteLocation(currentLocationIndex)
              : onDeleteContact(currentContactIndex)
          "
        >
          Yes, Delete
        </button>
      </div>
    </div>
  </div>
</ng-template>
